import { AnimationCredit } from '@/models/animation-credit';
import { Move } from '@/models/move';
import { MoveType } from '@/models/move-type';

const emiCredits: AnimationCredit = {
  name: 'Emi House',
  url: 'https://drive.fightcore.gg/',
};

const emptyCharacterStats = {
  id: 0,
  weight: 0,
  gravity: 0,
  walkSpeed: 0,
  runSpeed: 0,
  initialDash: 0,
  dashFrames: 0,
  waveDashLength: 0,
  waveDashLengthRank: 0,
  plaIntangibilityFrames: 0,
  jumpSquat: 0,
  canWallJump: false,
  notes: '',
};

export const ShowCaseMoves: Move[] = [
  {
    id: 1233,
    name: 'Down Air',
    normalizedName: 'dair',
    totalFrames: 49,
    type: MoveType.air,
    isInterpolated: false,
    start: 5,
    end: 27,
    landLag: 18,
    lCanceledLandLag: 9,
    autoCancelBefore: 5,
    autoCancelAfter: 33,
    pngUrl: 'https://i.fightcore.gg/png/fox/dair.png',
    gifUrl: 'https://i.fightcore.gg/beta/fox/dair.gif',
    webmUrl: 'https://i.fightcore.gg/beta/fox/dair.webm',
    characterId: 224,
    character: {
      moves: [],
      name: 'Fox',
      normalizedName: 'fox',
      fightCoreId: 224,
      characterStatistics: emptyCharacterStats,
    },
    animationCredit: emiCredits,
    hits: [
      {
        id: 2288,
        start: 5,
        end: 6,
        name: '',
        hitboxes: [
          {
            id: 8893,
            name: 'id0',
            damage: 3,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 3,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8894,
            name: 'id1',
            damage: 2,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 2,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
      {
        id: 2289,
        start: 8,
        end: 9,
        name: '',
        hitboxes: [
          {
            id: 8895,
            name: 'id0',
            damage: 3,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 3,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8896,
            name: 'id1',
            damage: 2,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 2,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
      {
        id: 2290,
        start: 11,
        end: 12,
        name: '',
        hitboxes: [
          {
            id: 8897,
            name: 'id0',
            damage: 3,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 3,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8898,
            name: 'id1',
            damage: 2,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 2,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
      {
        id: 2291,
        start: 14,
        end: 15,
        name: '',
        hitboxes: [
          {
            id: 8899,
            name: 'id0',
            damage: 3,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 3,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8900,
            name: 'id1',
            damage: 2,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 2,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
      {
        id: 2292,
        start: 17,
        end: 18,
        name: '',
        hitboxes: [
          {
            id: 8901,
            name: 'id0',
            damage: 3,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 3,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8902,
            name: 'id1',
            damage: 2,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 2,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
      {
        id: 2293,
        start: 20,
        end: 21,
        name: '',
        hitboxes: [
          {
            id: 8903,
            name: 'id0',
            damage: 3,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 3,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8904,
            name: 'id1',
            damage: 2,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 2,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
      {
        id: 2294,
        start: 23,
        end: 24,
        name: '',
        hitboxes: [
          {
            id: 8905,
            name: 'id0',
            damage: 3,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 3,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8906,
            name: 'id1',
            damage: 2,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 2,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
      {
        id: 2295,
        start: 26,
        end: 27,
        name: '',
        hitboxes: [
          {
            id: 8907,
            name: 'id0',
            damage: 3,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 3,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8908,
            name: 'id1',
            damage: 2,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 30,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 4,
            hitlagDefender: 4,
            hitlagAttackerCrouched: 2,
            hitlagDefenderCrouched: 2,
            shieldstun: 2,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
    ],
  },
  {
    id: 834,
    name: 'Forward Air',
    normalizedName: 'fair',
    totalFrames: 33,
    start: 4,
    end: 7,
    type: MoveType.air,
    isInterpolated: false,
    landLag: 15,
    lCanceledLandLag: 7,
    iasa: 30,
    autoCancelBefore: 1,
    autoCancelAfter: 26,
    pngUrl: 'https://i.fightcore.gg/png/marth/fair.png',
    gifUrl: 'https://i.fightcore.gg/beta/marth/fair.gif',
    webmUrl: 'https://i.fightcore.gg/beta/marth/fair.webm',
    animationCredit: emiCredits,
    characterId: 222,
    character: {
      moves: [],
      name: 'Marth',
      normalizedName: 'marth',
      fightCoreId: 222,
      characterStatistics: emptyCharacterStats,
    },
    hits: [
      {
        id: 2533,
        start: 4,
        end: 7,
        name: '',
        hitboxes: [
          {
            id: 9483,
            name: 'id0',
            damage: 10,
            angle: 361,
            knockbackGrowth: 70,
            setKnockback: 0,
            baseKnockback: 30,
            effect: 'Slash',
            hitlagAttacker: 6,
            hitlagDefender: 6,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 6,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 9484,
            name: 'id1',
            damage: 9,
            angle: 361,
            knockbackGrowth: 70,
            setKnockback: 0,
            baseKnockback: 20,
            effect: 'Slash',
            hitlagAttacker: 6,
            hitlagDefender: 6,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 6,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 9485,
            name: 'id2',
            damage: 9,
            angle: 361,
            knockbackGrowth: 70,
            setKnockback: 0,
            baseKnockback: 20,
            effect: 'Slash',
            hitlagAttacker: 6,
            hitlagDefender: 6,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 6,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 9486,
            name: 'id3',
            damage: 13,
            angle: 67,
            knockbackGrowth: 70,
            setKnockback: 0,
            baseKnockback: 42,
            effect: 'Slash',
            hitlagAttacker: 7,
            hitlagDefender: 7,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 7,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
    ],
  },
  {
    id: 1335,
    name: 'Down Air',
    normalizedName: 'dair',
    totalFrames: 49,
    start: 5,
    end: 24,
    type: MoveType.air,
    isInterpolated: false,
    landLag: 18,
    lCanceledLandLag: 9,
    autoCancelBefore: 5,
    autoCancelAfter: 29,
    pngUrl: 'https://i.fightcore.gg/png/falco/dair.png',
    gifUrl: 'https://i.fightcore.gg/beta/falco/dair.gif',
    webmUrl: 'https://i.fightcore.gg/beta/falco/dair.webm',
    animationCredit: emiCredits,
    characterId: 218,
    character: {
      moves: [],
      name: 'Falco',
      normalizedName: 'falco',
      fightCoreId: 218,
      characterStatistics: emptyCharacterStats,
    },
    hits: [
      {
        id: 2260,
        start: 5,
        end: 14,
        name: '',
        hitboxes: [
          {
            id: 8825,
            name: 'id0',
            damage: 12,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 10,
            effect: 'Normal',
            hitlagAttacker: 7,
            hitlagDefender: 7,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 7,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8826,
            name: 'id1',
            damage: 12,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 10,
            effect: 'Normal',
            hitlagAttacker: 7,
            hitlagDefender: 7,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 7,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
      {
        id: 2261,
        start: 15,
        end: 24,
        name: '',
        hitboxes: [
          {
            id: 8827,
            name: 'id0',
            damage: 9,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 20,
            effect: 'Normal',
            hitlagAttacker: 6,
            hitlagDefender: 6,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 6,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8828,
            name: 'id1',
            damage: 9,
            angle: 290,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 20,
            effect: 'Normal',
            hitlagAttacker: 6,
            hitlagDefender: 6,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 6,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
    ],
  },
  {
    id: 961,
    name: 'Back Air',
    normalizedName: 'bair',
    totalFrames: 39,
    start: 9,
    end: 12,
    type: MoveType.air,
    isInterpolated: false,
    landLag: 20,
    lCanceledLandLag: 10,
    iasa: 31,
    autoCancelBefore: 9,
    autoCancelAfter: 24,
    pngUrl: 'https://i.fightcore.gg/png/jigglypuff/bair.png',
    gifUrl: 'https://i.fightcore.gg/beta/jigglypuff/bair.gif',
    webmUrl: 'https://i.fightcore.gg/beta/jigglypuff/bair.webm',
    animationCredit: emiCredits,
    characterId: 214,
    character: {
      moves: [],
      name: 'Jigglypuff',
      normalizedName: 'jigglypuff',
      fightCoreId: 214,
      characterStatistics: emptyCharacterStats,
    },
    hits: [
      {
        id: 3505,
        start: 9,
        end: 12,
        name: '',
        hitboxes: [
          {
            id: 11671,
            name: 'id0',
            damage: 12,
            angle: 361,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 10,
            effect: 'Normal',
            hitlagAttacker: 7,
            hitlagDefender: 7,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 7,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 11672,
            name: 'id1',
            damage: 12,
            angle: 361,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 10,
            effect: 'Normal',
            hitlagAttacker: 7,
            hitlagDefender: 7,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 7,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 11673,
            name: 'id2',
            damage: 12,
            angle: 361,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 10,
            effect: 'Normal',
            hitlagAttacker: 7,
            hitlagDefender: 7,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 7,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
    ],
  },
  {
    id: 1227,
    name: 'Up Smash',
    normalizedName: 'usmash',
    totalFrames: 41,
    start: 7,
    end: 17,
    type: MoveType.grounded,
    isInterpolated: false,
    pngUrl: 'https://i.fightcore.gg/png/fox/usmash.png',
    gifUrl: 'https://i.fightcore.gg/beta/fox/usmash.gif',
    webmUrl: 'https://i.fightcore.gg/beta/fox/usmash.webm',
    animationCredit: emiCredits,
    characterId: 224,
    character: {
      moves: [],
      name: 'Fox',
      normalizedName: 'fox',
      fightCoreId: 224,
      characterStatistics: emptyCharacterStats,
    },
    hits: [
      {
        id: 2278,
        start: 7,
        end: 9,
        name: '',
        hitboxes: [
          {
            id: 8869,
            name: 'id0',
            damage: 18,
            angle: 80,
            knockbackGrowth: 112,
            setKnockback: 0,
            baseKnockback: 30,
            effect: 'Normal',
            hitlagAttacker: 9,
            hitlagDefender: 9,
            hitlagAttackerCrouched: 6,
            hitlagDefenderCrouched: 6,
            shieldstun: 10,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8870,
            name: 'id1',
            damage: 18,
            angle: 80,
            knockbackGrowth: 112,
            setKnockback: 0,
            baseKnockback: 30,
            effect: 'Normal',
            hitlagAttacker: 9,
            hitlagDefender: 9,
            hitlagAttackerCrouched: 6,
            hitlagDefenderCrouched: 6,
            shieldstun: 10,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
      {
        id: 2279,
        start: 10,
        end: 17,
        name: '',
        hitboxes: [
          {
            id: 8871,
            name: 'id0',
            damage: 13,
            angle: 361,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 10,
            effect: 'Normal',
            hitlagAttacker: 7,
            hitlagDefender: 7,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 7,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8872,
            name: 'id1',
            damage: 13,
            angle: 361,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 10,
            effect: 'Normal',
            hitlagAttacker: 7,
            hitlagDefender: 7,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 7,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
    ],
  },
  {
    id: 830,
    name: 'Forward Smash',
    normalizedName: 'fsmash',
    totalFrames: 49,
    start: 10,
    end: 13,
    type: MoveType.grounded,
    isInterpolated: false,
    iasa: 48,
    pngUrl: 'https://i.fightcore.gg/png/marth/fsmash.png',
    gifUrl: 'https://i.fightcore.gg/beta/marth/fsmash.gif',
    webmUrl: 'https://i.fightcore.gg/beta/marth/fsmash.webm',
    animationCredit: emiCredits,
    characterId: 222,
    character: {
      moves: [],
      name: 'Marth',
      normalizedName: 'marth',
      fightCoreId: 222,
      characterStatistics: emptyCharacterStats,
    },
    hits: [
      {
        id: 2527,
        start: 10,
        end: 13,
        name: '',
        hitboxes: [
          {
            id: 9459,
            name: 'id0',
            damage: 14,
            angle: 361,
            knockbackGrowth: 70,
            setKnockback: 0,
            baseKnockback: 60,
            effect: 'Slash',
            hitlagAttacker: 8,
            hitlagDefender: 8,
            hitlagAttackerCrouched: 5,
            hitlagDefenderCrouched: 5,
            shieldstun: 8,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 9460,
            name: 'id1',
            damage: 14,
            angle: 361,
            knockbackGrowth: 70,
            setKnockback: 0,
            baseKnockback: 60,
            effect: 'Slash',
            hitlagAttacker: 8,
            hitlagDefender: 8,
            hitlagAttackerCrouched: 5,
            hitlagDefenderCrouched: 5,
            shieldstun: 8,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 9461,
            name: 'id2',
            damage: 14,
            angle: 361,
            knockbackGrowth: 70,
            setKnockback: 0,
            baseKnockback: 60,
            effect: 'Slash',
            hitlagAttacker: 8,
            hitlagDefender: 8,
            hitlagAttackerCrouched: 5,
            hitlagDefenderCrouched: 5,
            shieldstun: 8,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 9462,
            name: 'id3',
            damage: 20,
            angle: 361,
            knockbackGrowth: 70,
            setKnockback: 0,
            baseKnockback: 80,
            effect: 'Slash',
            hitlagAttacker: 10,
            hitlagDefender: 10,
            hitlagAttackerCrouched: 6,
            hitlagDefenderCrouched: 6,
            shieldstun: 10,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
    ],
  },
  {
    id: 1103,
    name: 'Forward Air',
    normalizedName: 'fair',
    totalFrames: 39,
    start: 14,
    end: 30,
    type: MoveType.air,
    isInterpolated: false,
    landLag: 19,
    lCanceledLandLag: 9,
    iasa: 36,
    autoCancelBefore: 7,
    autoCancelAfter: 34,
    pngUrl: 'https://i.fightcore.gg/png/captainfalcon/fair.png',
    gifUrl: 'https://i.fightcore.gg/beta/captainfalcon/fair.gif',
    webmUrl: 'https://i.fightcore.gg/beta/captainfalcon/fair.webm',
    animationCredit: emiCredits,
    characterId: 227,
    character: {
      moves: [],
      name: 'Captain Falcon',
      normalizedName: 'captainfalcon',
      fightCoreId: 227,
      characterStatistics: emptyCharacterStats,
    },
    hits: [
      {
        id: 2174,
        start: 14,
        end: 16,
        name: '',
        hitboxes: [
          {
            id: 8603,
            name: 'id0',
            damage: 18,
            angle: 32,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 24,
            effect: 'Electric',
            hitlagAttacker: 9,
            hitlagDefender: 13,
            hitlagAttackerCrouched: 6,
            hitlagDefenderCrouched: 8,
            shieldstun: 10,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8604,
            name: 'id1',
            damage: 18,
            angle: 32,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 24,
            effect: 'Electric',
            hitlagAttacker: 9,
            hitlagDefender: 13,
            hitlagAttackerCrouched: 6,
            hitlagDefenderCrouched: 8,
            shieldstun: 10,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
      {
        id: 2175,
        start: 17,
        end: 30,
        name: '',
        hitboxes: [
          {
            id: 8605,
            name: 'id0',
            damage: 6,
            angle: 361,
            knockbackGrowth: 80,
            setKnockback: 0,
            baseKnockback: 35,
            effect: 'Normal',
            hitlagAttacker: 5,
            hitlagDefender: 5,
            hitlagAttackerCrouched: 3,
            hitlagDefenderCrouched: 3,
            shieldstun: 4,
            yoshiArmorBreakPercentage: 0,
          },
          {
            id: 8606,
            name: 'id1',
            damage: 6,
            angle: 361,
            knockbackGrowth: 80,
            setKnockback: 0,
            baseKnockback: 35,
            effect: 'Normal',
            hitlagAttacker: 5,
            hitlagDefender: 5,
            hitlagAttackerCrouched: 3,
            hitlagDefenderCrouched: 3,
            shieldstun: 4,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
    ],
  },
  {
    id: 1131,
    name: 'Forward Air',
    normalizedName: 'fair',
    totalFrames: 33,
    start: 5,
    end: 7,
    type: MoveType.air,
    isInterpolated: false,
    landLag: 16,
    lCanceledLandLag: 8,
    autoCancelBefore: 5,
    autoCancelAfter: 10,
    pngUrl: 'https://i.fightcore.gg/png/sheik/fair.png',
    gifUrl: 'https://i.fightcore.gg/beta/sheik/fair.gif',
    webmUrl: 'https://i.fightcore.gg/beta/sheik/fair.webm',
    animationCredit: emiCredits,
    characterId: 260,
    character: {
      moves: [],
      name: 'Sheik',
      normalizedName: 'sheik',
      fightCoreId: 260,
      characterStatistics: emptyCharacterStats,
    },
    hits: [
      {
        id: 2848,
        start: 5,
        end: 7,
        name: '',
        hitboxes: [
          {
            id: 10254,
            name: 'id0',
            damage: 13,
            angle: 25,
            knockbackGrowth: 100,
            setKnockback: 0,
            baseKnockback: 0,
            effect: 'Normal',
            hitlagAttacker: 7,
            hitlagDefender: 7,
            hitlagAttackerCrouched: 4,
            hitlagDefenderCrouched: 4,
            shieldstun: 7,
            yoshiArmorBreakPercentage: 0,
          },
        ],
      },
    ],
  },
];
